exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mt_top[data-v-fb656fc8]{margin-top:4px}.text_title[data-v-fb656fc8]{font-size:14px;color:rgba(0,0,0,.85)}.header_box[data-v-fb656fc8]{width:100%;height:63px;background:#e7efff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0 20px}.header_box .name_span[data-v-fb656fc8]{margin-left:30px;font-weight:600;font-size:18px;color:#474245}.block_representation[data-v-fb656fc8]{width:4px;height:18px;background:#4d8aff;border-radius:2px}.block_title[data-v-fb656fc8]{font-weight:600;font-size:18px;color:#474245;margin-left:10px}", ""]);

// exports
